import {
    Component,
    DoCheck,
    Input,
    IterableDiffer,
    IterableDiffers,
    OnInit,
    Output,
    QueryList,
    ViewChildren
} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {map} from "rxjs/operators";
import {Router} from "@angular/router";
import {MatExpansionPanel} from "@angular/material/expansion";
import {HttpParams} from "@angular/common/http";
import {SessionService} from "../../session/session.service";
import {Usuario} from "../../model/personas/usuario.model";
import {Persona} from "../../model/personas/persona.model";
import {EmbalajeComponent} from "../../pages/logistica/embalaje.component";
import {Cliente} from "../../model/personas/cliente.model";
import {environment} from "../../../environments/environment";
import {ConversacionesService} from "../../pages/mensajes/conversaciones.service";
import {puedeUsarMensajes} from "../../pages/mensajes/acceso-mensajes";

export const MENU_ENDPOINT = 'items';

export interface MenuItem {

}

@Component({
    selector: 'app-sidenavHeader',
    templateUrl: './sidenavHeader.component.html',
    styleUrls: ['./sidenavHeader.component.scss']
})
export class SidenavHeaderComponent implements OnInit {
    private static nextId = 0;
    private _id;
    public version = environment.version;
    public readonly pendientes$: Observable<number>;


    constructor(private _router: Router, private _sesion: SessionService, conversaciones: ConversacionesService) {
        this.pendientes$ = conversaciones.resumen$.pipe(map(r => r.pendientesRespuesta ?? 0));
    }

    /** Sobre de mensajes para un empleado o un comercial con ROLE_MENSAJES (acceso-mensajes.ts). */
    public get mensajes(): boolean {
        return puedeUsarMensajes(this._sesion);
    }

    ngOnInit(): void {


    }

    public logout() {
        this._sesion.logout();
        this._router.navigateByUrl('/').then();
        window.location.reload();

    }

    public get profileName(): string {
        const profile = this._sesion.profile;
        if (profile instanceof Usuario) {
            return profile.username;
        } else if (profile instanceof Persona) {
            return SidenavHeaderComponent.nombreVisible(profile) || profile.usuario?.username || '';
        }
        return '';
    }

    /**
     * La misma regla que PersonaSuperclass::getNombreCompleto() de la API: un cliente empresa se
     * muestra por su denominación social y una persona por nombre y apellidos, juntando solo las
     * partes con texto (a muchos les falta algún apellido). Se recompone aquí porque `/me`
     * serializa con el grupo 'personas' y `nombreCompleto` solo sale en 'personas_out'.
     */
    private static nombreVisible(persona: Persona): string {
        const denominacion = persona instanceof Cliente && persona.empresa ? persona.denominacionSocial?.trim() : '';
        return denominacion || [persona.nombre, persona.apellido1, persona.apellido2]
            .map(parte => (parte ?? '').trim())
            .filter(parte => parte !== '')
            .join(' ');
    }
}
